import { useMemo } from 'react';
import { useAuth } from '../auth/authProvider';

// Route priority order - first accessible route becomes the default landing page
const routePriority = [
  { path: '/licenses', resource: 'licenses', action: 'read' },
  { path: '/customers', resource: 'customers', action: 'read' },
  { path: '/releases', resource: 'updates', action: 'read' },
  { path: '/analytics', resource: 'analytics', action: 'read' },
  { path: '/users', resource: 'users', action: 'read' },
  { path: '/audit', resource: 'audit', action: 'read' },
  { path: '/api-keys', resource: 'api_keys', action: 'read' },
];

export const useDefaultRoute = (): string | null => {
  const { hasPermission } = useAuth();

  const defaultRoute = useMemo(() => {
    for (const route of routePriority) {
      if (hasPermission(route.resource, route.action)) {
        return route.path;
      }
    }
    return null;
  }, [hasPermission]);

  return defaultRoute;
};
